import React, { useState } from 'react';
import {
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography
} from '@mui/material';
import PostData from '../../services/PostData';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

export default function SplitOrderDialog({ record, close }) {
    const originalItemTitle = record && record.length > 0 ? record[0].fields?.["Item Title"] : '';
    const recordId = record && record.length > 0 ? record[0].id : '';
    const orderNum = record && record.length > 0 ? record[0].fields?.["Order Number"] : '';
    const originalQuantity = record && record.length > 0 ? record[0].fields?.["Quantity"] : 1;
    const [successSubmit, setSuccessSubmit] = useState(false)
    const [splitShipments, setSplitShipments] = useState([
        { id: 1, quantity: originalQuantity } // Initialize with one shipment, taking the full original quantity
    ]);

    const [submitLoad, setSubmitLoad] = useState(false); // For future "Create Label" or "Split Order" action

    const handleAddShipment = () => {
        // Calculate remaining quantity if you want new shipments to default to that
        const totalAllocated = splitShipments.reduce((sum, s) => sum + s.quantity, 0);
        const remainingQuantity = originalQuantity - totalAllocated;

        setSplitShipments(prev => [
            ...prev,
            { id: prev.length + 1, quantity: Math.max(1, remainingQuantity) } // New shipment defaults to remaining or 1
        ]);
    };

    const handleRemoveShipment = (idToRemove) => {
        if (splitShipments.length > 1) { // Ensure at least one shipment remains
            setSplitShipments(prev => prev.filter(s => s.id !== idToRemove));
        }
    };

    const handleShipmentQuantityChange = (idToUpdate, newQuantity) => {
        const parsedQuantity = parseInt(newQuantity, 10);
        if (isNaN(parsedQuantity) || parsedQuantity < 1) return; // Basic validation

        setSplitShipments(prev => {
            const updatedShipments = prev.map(s =>
                s.id === idToUpdate ? { ...s, quantity: parsedQuantity } : s
            );

            // Calculate total quantity to ensure it doesn't exceed originalQuantity
            const totalAllocated = updatedShipments.reduce((sum, s) => sum + s.quantity, 0);

            if (totalAllocated <= originalQuantity) {
                return updatedShipments;
            } else {
                return prev.map(s => {
                    if (s.id === idToUpdate) {
                        const otherShipmentsTotal = prev.filter(p => p.id !== idToUpdate).reduce((sum, p) => sum + p.quantity, 0);
                        return { ...s, quantity: Math.max(1, originalQuantity - otherShipmentsTotal) };
                    }
                    return s;
                });
            }
        });
    };
    const handleSubmitSplitOrder = async () => {
        setSubmitLoad(true);
        const payload = { splitShipments, "orderNumber": orderNum, "recordId": recordId }
        const { success, error } = await PostData(payload, "broylesllc/shipping/split-order-label", null)
        if (success) {
            setSubmitLoad(false);
            setSuccessSubmit(true);
            setTimeout(() => {
                window.location.assign(`${window.location.origin}/order-shipping?t=1&v=nl`);
            }, 1000);
        }
    };

    return (
        <>
            <DialogTitle>
                Split Order
                <div>
                    <IconButton
                        onClick={close}
                        sx={{
                            position: 'absolute', width: '40px', height: '40px', top: '10px', right: '30px',
                            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                            backgroundColor: 'white', zIndex: 100, "&:hover": { backgroundColor: '#f0f0f0' }
                        }}
                    >
                        <CloseIcon sx={{ cursor: 'pointer' }} />
                    </IconButton>
                </div>
            </DialogTitle>
            <hr style={{ margin: 0 }} />
            <DialogContent>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16, paddingTop: 8 }}>
                    <Typography variant='subtitle2'>Order Num: {orderNum}</Typography>
                    <TextField
                        label="Item Name"
                        value={originalItemTitle}
                        fullWidth
                        InputProps={{
                            readOnly: true,
                        }}
                        variant="outlined"
                        size="small"
                    />
                    {splitShipments.map((shipment, index) => (
                        <div key={shipment.id} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <TextField
                                label={`Shipment ${index + 1} Quantity`}
                                type="number"
                                value={shipment.quantity}
                                onChange={(e) => handleShipmentQuantityChange(shipment.id, e.target.value)}
                                fullWidth
                                variant="outlined"
                                size="small"
                                inputProps={{ min: 1 }} // Max will be handled by the total validation
                                helperText={`Total remaining: ${originalQuantity - splitShipments.reduce((sum, s) => sum + s.quantity, 0)}`}
                            />
                            {splitShipments.length > 1 && (
                                <IconButton aria-label="remove" size="small" color="error" onClick={() => handleRemoveShipment(shipment.id)}>
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            )}
                            {index === splitShipments.length - 1 && ( // Add button only on the last visible shipment
                                <IconButton aria-label="add" size="small" sx={{ color: '#3E5C76' }} onClick={handleAddShipment} >
                                    <AddIcon fontSize="small" />
                                </IconButton>
                            )}
                        </div>
                    ))}

                </div>
            </DialogContent>
            <DialogActions>
                {/* <Button onClick={close}>Cancel</Button> */}
                <Button
                    variant="contained"
                    loading={submitLoad}
                    disableElevation
                    disabled={submitLoad}
                    sx={{ textTransform: 'none', minWidth: '200px', background: successSubmit ? 'green' : '#FF8C61' }}
                    onClick={handleSubmitSplitOrder}
                >
                    {successSubmit ?
                        <>
                            <span>Success</span>
                            <CheckOutlinedIcon fontSize="small"
                                sx={{ color: 'white', marginLeft: '10px' }} />
                        </>
                        : "Create Split Label"
                    }
                </Button>
            </DialogActions>
        </>
    );
}